import React, { useState } from 'react';
import {
  addPathToList,
  getSubCategoryId,
  Manual_recipient_options,
  must_have_one,
  ok_str,
  one_selection_enabled,
  Select_manual_transfer,
  select_recipient,
} from '../../../utils/DictionaryManagementUtils';
import FullPagePanel from '../General/FullPagePanel';
import { LocStr } from '../../../utils/Utils';
import { arrangeScreenInJson } from '../../../screens/ScreensOrdering';
import ManuelRecipientMenu from '../ManuelRecipient/ManuelRecipientMenu';
import NoteMessage from '../Text/NoteMessage';
import MyMessagePopup from '../../MyMessagePopup';

//= ========================================================================

const DefaultTransferMethod = ({
  globJSON,
  onConfigChanged,
  selectedScreen,
  onStepPressed,
  onGotoEdit,
  language,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const subCategoryIdDefault = getSubCategoryId({
    sub_category: myScreen.sub_category,
    duplication_number: 0,
  });
  const service = globJSON.configurations.services[subCategoryId];
  const { recipient } = service;

  const editTextList = addPathToList(['select_recipient_details_type'], `configurations/services/${subCategoryId}/recipient/`)
    .concat(recipient.screens_ordering.filter((manualKey) => recipient.manual_recipients[manualKey].selected)
      .map((manualKey) => `configurations/services/${subCategoryId}/recipient/manual_recipients/${manualKey}/manual_name`));
  const editTextListDefault = addPathToList(['select_recipient_details_type'], `configurations/services/${subCategoryIdDefault}/recipient/`)
    .concat(recipient.screens_ordering.filter((manualKey) => recipient.manual_recipients[manualKey].selected)
      .map((manualKey) => `configurations/services/${subCategoryIdDefault}/recipient/manual_recipients/${manualKey}/manual_name`));

  const [messagePopupState, setMessagePopupState] = useState({
    isMessageVisible: false,
    title: '',
  });
  const countOptions = () => Object.values(recipient.manual_recipients)
    .filter((manual_recipient) => manual_recipient.selected).length;
  const onlyOneSelected = countOptions() <= 1;
  const onManualMethodValueChanged = (theKey, value) => {
    if (!value && countOptions() === 1) {
      const txt = LocStr(must_have_one, language);
      setMessagePopupState({
        isMessageVisible: true,
        title: txt,
      });
      return;
    }

    recipient.manual_recipients[theKey].selected = value;
    arrangeScreenInJson(globJSON, onConfigChanged);
  };

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={select_recipient}
      panelSubHeadline={Manual_recipient_options}
      editTextList={editTextList}
      editTextListDefault={editTextListDefault}
      tooltipsTitles={service.screens_ordering}
      paragraph={Select_manual_transfer}
      language={language}
      isHollow
    >
      <ManuelRecipientMenu
        globJSON={globJSON}
        subCategoryId={subCategoryId}
        onManualMethodValueChanged={onManualMethodValueChanged}
        language={language}
        onConfigChanged={onConfigChanged}
      />
      {onlyOneSelected && (<NoteMessage language={language}>{one_selection_enabled}</NoteMessage>)}
      {messagePopupState.isMessageVisible && (
        <MyMessagePopup
          onOkPressed={() => setMessagePopupState({
            isMessageVisible: false,
            title: '',
          })}
          okTitle={LocStr(ok_str, language)}
          message={messagePopupState.title}
          marginTop="40%"
          language={language}
        />
      )}
    </FullPagePanel>
  );
};

export default DefaultTransferMethod;
